import React from 'react';

export const PageLayout = ({ children }) => (
  <div className="m-4 px-16 mx-2 flex flex-col xl:flex-row justify-center items-center xl:items-start h-full">
    { children }
  </div>
)

export default PageLayout;
